import { render, staticRenderFns } from "./DirectTransactionChange.vue?vue&type=template&id=1d1525b6&scoped=true&"
import script from "./DirectTransactionChange.vue?vue&type=script&lang=js&"
export * from "./DirectTransactionChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1525b6",
  null
  
)

export default component.exports